import { render } from "./head-comp.vue?vue&type=template&id=33230b8a&scoped=true"
import script from "./head-comp.vue?vue&type=script&lang=js"
export * from "./head-comp.vue?vue&type=script&lang=js"

import "./head-comp.vue?vue&type=style&index=0&id=33230b8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33230b8a"]])

export default __exports__